<template>
    <div class="title_ss">Shpërndarja e përmbajtjeve mësimore të detyrave sipas grupeve për shkolla të mesme të ulëta dhe të larta</div>
    <br>
    <div class="text">
        Detyrat për të gjitha nivelet e garave dhe për të gjitha grupet përfshijnë përmbajtjen
        (temat) e kaluara të klasës përkatëse (temat e nënvizuara), si dhe përmbajtjen (temat)
        e të gjitha klasave të mëparshme, psh detyrat për klasën e 10 do të jenë detyra
        kryesisht nga temat e kaluara në gjysmëvjetorin e parë të klasës së 10 (temat e
        nënvizuara) si dhe detyra e klasës së 9 e kështu me rradhë.
    </div>
    <div class="text">
        <div class="subsub_title center">Grupi I</div>
        Përmbajtja (temat) e klasës së mëparshme si dhe përmbajtja (temat) e bazuar në
        programet mësimore të klasës së 7:
        <ol class="blue">
            <li style="text-decoration: underline;">Matjet themelore</li>
            <li style="text-decoration: underline;">Lëvizjet e thjeshta</li>
            <li style="text-decoration: underline;">Forca dhe lëvizjet</li>
            <li style="text-decoration: underline;">Puna mekanike</li>
            <br>
            <li>Energjia</li>
            <li>Zëri dhe përhapja e tij</li>
            <li>Gjendjet agregate</li>
            <li>Parimi i punës së makinave të thjeshta</li>
        </ol>
        Përmbajtja (temat) e klasës së mëparshme si dhe përmbajtja (temat) e bazuar në programet mësimore të klasës së 8:
        <ol class="blue">
            <li style="text-decoration: underline;">Lëvizjet e nxituara</li>
            <li style="text-decoration: underline;">Ligjet themelore të mekanikës</li>
            <li style="text-decoration: underline;">Zbatimi i ligjit të dytë të mekanikës</li>
            <li style="text-decoration: underline;">Lëvizja rrethore</li>
            <br>
            <li>Shtypja në fluide</li>
            <li>Lëkundjet dhe valët</li>
            <li>Energjia e nxehtësisë</li>
            <li>Ëigjet e gazeve ideale</li>
        </ol>
        Përmbajtja (temat) e klasës së mëparshme si dhe përmbajtja (temat) e bazuar në programet mësimore të klasës së 9: 
        <ol class="blue">
            <li style="text-decoration: underline;">Termodinamika</li>
            <li style="text-decoration: underline;">Ngarkesat elektrike</li>
            <li style="text-decoration: underline;">Ligjet e rrymës elektrike</li>
            <li style="text-decoration: underline;">Fusha magnetike</li>
            <br>
            <li>Induksioni elektromagnetik</li>
            <li>Përhapja drejtvizore e dritës</li>
            <li>Struktura e atomit dhe e bërthamës</li>
            <li>Fizika e gjysmëpërçuesve</li>
            <li>Kozmologjia</li>
        </ol>
    </div>
    <div class="text">
        <div class="subsub_title center">Grupi II</div>
        Përmbajtjet (temat) e klasëve të mëparshme si dhe përmbajtja (temat) e bazuar në programet mësimore të klasës së 10:
        <ol class="blue">
            <li style="text-decoration: underline;">Lënda e studimit të fizikës</li>
            <li style="text-decoration: underline;">Lëvizjet e thjeshta dhe të përbëra</li>
            <li style="text-decoration: underline;">Zbatimi i ligjit të dytë të mekanikës</li>
            <li style="text-decoration: underline;">Ligji i parë dhe ligji i dytë i Njutonit</li>
            <li style="text-decoration: underline;">Ligji i tretë i Njutonit</li>
            <li style="text-decoration: underline;">Energjia dhe ligji i ruajtjes së saj</li>
            <li style="text-decoration: underline;">Ligji i Njutonit për gravitet</li>
            <br>
            <li>Struktura e lëndës dhe gazet ideale</li>
            <li>Nxehtësia dhe format tjera të energjisë</li>
            <li>Ndërrimet e gjendjes agregate</li>
        </ol>
    </div>
    <div class="text">
        <div class="subsub_title center">Grupi III</div>
        Përmbajtjet (temat) e klasëve të mëparshme si dhe përmbajtja (temat) e bazuar në programet mësimore të klasës së 11:
        <ol class="blue">
            <li style="text-decoration: underline;">Lëkundjet dhe valët</li>
            <li style="text-decoration: underline;">Zëri</li>
            <li style="text-decoration: underline;">Lëngjet në prehje dhe rrymimi i tyre</li>
            <li style="text-decoration: underline;">Ngarkesat elektrike dhe rrymat njëkahore</li>
            <br>
            <li>Fushat magnetike</li>
            <li>Forcat në fushën magnetike</li>
            <li>Induksioni elektromagnetik dhe rrymat alternative</li>
            <li>Fushat elektromagnetike</li>
            <li>Fotometria dhe madhësitë fotometrike</li>
        </ol>
    </div>
    <div class="text">
        <div class="subsub_title center">Grupi IV</div>
        Përmbajtjet (temat) e klasëve të mëparshme si dhe përmbajtja (temat) e bazuar në programet mësimore të klasës së 12:
        <ol class="blue">
            <li style="text-decoration: underline;">Optika gjeometrike</li>
            <li style="text-decoration: underline;">Optika valore</li>
            <li style="text-decoration: underline;">Teoria speciale e relativitetit (TSR)</li>
            <li style="text-decoration: underline;">Rrezatimi termik</li>
            <br>
            <li>Struktura e atomit</li>
            <li>Bërthama e atomit dhe grimcat elementare</li>
            <li>Fizika e trupit të ngurtë</li>
            <li>Ushtrime laboratori</li>
        </ol>
    </div>
    <div class="text"><br><br><br>Rekomandohet që nxënësit në grupe të vogla të përgaditen për pjesëmarrjen në këto gara nën udhëheqjen e një mentori.</div>
    
</template>

<style>
.u{
    text-decoration: underline;
}
.blue{
    color: rgb(69, 175, 242);
}

</style>